import { useEffect, useRef, useState } from 'react';

export const useCollabConnectedTimeout = (
	collabEditInitialized: boolean,
	isCollabProviderConnected: boolean,
	onConnectionTimedOut?: () => void,
): { collabEditConnectionTimedOut: boolean } => {
	const COLLAB_CONNECTED_TIMEOUT_MS = 10000; // 10 second timeout

	const [collabEditConnectionTimedOut, setCollabEditConnectionTimedOut] = useState(false);
	const onConnectionTimedOutRef = useRef<(() => void) | undefined>(undefined);
	onConnectionTimedOutRef.current = onConnectionTimedOut;

	useEffect(() => {
		// short-circuit when new collab service is already initialized, COLLAB_INIT_TIMEOUT_MS has not been set
		// if collab provider is connected after X seconds we don't want to show the banner anymore
		if (!collabEditInitialized) {
			return;
		}

		if (isCollabProviderConnected) {
			setCollabEditConnectionTimedOut(false);
			return;
		}

		const timeout = setTimeout(() => {
			setCollabEditConnectionTimedOut(true);
			onConnectionTimedOutRef.current?.();
		}, COLLAB_CONNECTED_TIMEOUT_MS);

		return () => {
			clearTimeout(timeout);
		};
	}, [isCollabProviderConnected, collabEditInitialized, COLLAB_CONNECTED_TIMEOUT_MS]);
	return { collabEditConnectionTimedOut };
};
